import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { isv_redeem_form_radio_PG, isv_total_redeem_form_keys, total_redeem_form_keys } from './total-redeem.constants';
import { Subject } from 'rxjs';
import { IIbanObject } from '../../../athora/athora.constants';
import { PolicyService } from 'src/app/modules/policy/policy.service';

@Component({
  selector: 'app-total-redeem',
  templateUrl: './total-redeem.component.html',
  styleUrl: './total-redeem.component.scss',
})
export class TotalRedeemComponent implements OnChanges, OnDestroy {

  @Input() form: FormGroup;
  @Input() ibanList: IIbanObject[];

  formKeys: IFormKey[];

  destroy$ = new Subject();

  constructor(
    private readonly _policyService: PolicyService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['ibanList'] && changes['ibanList'].currentValue) {
      if (this.isPolicyAthora) {
        this.formKeys = total_redeem_form_keys;
      } else {
        const formKeys = [...isv_total_redeem_form_keys];
        if (this._policyService.isLegalSubject) {
          formKeys.push(isv_redeem_form_radio_PG);
        }
        this.formKeys = formKeys;
      }
      this.populateIbanOptions();
    }
  }

  populateIbanOptions(): void {
    this.formKeys = CommonUtils.populateIbanOptions(this.formKeys, this.ibanList);
  }

  get isPolicyAthora(): boolean {
    return this._policyService.isAthoraPolicy;
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
